import * as React from "react";

const DuplicateFilterIcon = ({ color = "#ffaa01", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23.514} height={20} {...props}>
    <g fill="none" strokeLinecap="round">
      <path
        data-name="Path 554"
        d="M18.382 7.453a9.115 9.115 0 0 1 .36 2.547 8.872 8.872 0 1 1-8.871-9 8.789 8.789 0 0 1 1.554.138"
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={2}
      />
      <g data-name="Path 397" strokeLinejoin="round">
        <path d="m15.062 10.9 1.188-9.693 6.505 6.321s-4.334-.021-4.325-.001-3.368 3.373-3.368 3.373Z" />
        <path
          d="m15.062 10.9 1.188-9.694 6.505 6.323s-4.335-.022-4.324 0c.01.021-3.369 3.37-3.369 3.37Z"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

export default DuplicateFilterIcon;
